import _extends from "@babel/runtime/helpers/esm/extends";
import { DATA_GRID_DEFAULT_SLOTS_COMPONENTS } from '@mui/x-data-grid/internals';
import { GridPushPinRightIcon, GridPushPinLeftIcon } from '../components';
import { GridProColumnMenu } from '../components/GridProColumnMenu';
export const DEFAULT_GRID_PRO_ICON_SLOTS_COMPONENTS = {
  ColumnMenuPinRightIcon: GridPushPinRightIcon,
  ColumnMenuPinLeftIcon: GridPushPinLeftIcon
};
export const DATA_GRID_PRO_DEFAULT_SLOTS_COMPONENTS = _extends({}, DATA_GRID_DEFAULT_SLOTS_COMPONENTS, DEFAULT_GRID_PRO_ICON_SLOTS_COMPONENTS, {
  ColumnMenu: GridProColumnMenu
});